import Router from 'next/router';

import { getLink, KnownRoutes } from './route';

export const isInViewport = (element: Element): boolean => {
    const rect = element.getBoundingClientRect();
    const offset = 50;
    return (
        rect.top >= -offset &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
};

type GoToPageOptions = { onSuccess?: () => void };
export const goToPage = (route: string | KnownRoutes, options: GoToPageOptions = {}) => {
    const { onSuccess } = options;
    Router.push(getLink(route)).then(onSuccess);
};
